import React from 'react';
import GPT from '@op/components/GPT';
import './index.scss';
import { AI_MODAL_OPTIONS, DEFAULT_MODAL } from '@op/components/GPT/constants';

export default function GPTAgent(props: any) {
  const { defaultValue } = props;
  const { promptInfo } = defaultValue || {};
  return (
    <div className="dbo-gpt-agent-wrapper">
      <GPT.AgentOptions
        gptType={promptInfo?.modelType || DEFAULT_MODAL}
        setGptType={() => {}}
        options={AI_MODAL_OPTIONS}
      ></GPT.AgentOptions>
    </div>
  );
}
